export default function InstructorReveal({ children }: { children: React.ReactNode }) {
  return (
    <div className="bg-surface-1 rounded-2xl p-6 border border-white/[0.08] flex mt-4 gap-3 overflow-hidden">
      <p className="w-28 text-sm shrink-0">Beklenen cevap <span className="block text-xs text-white/40 mt-0.5">(Öğrenciler görmüyor)</span></p>
      <div className="flex-1 min-w-0 overflow-auto">{children}</div>
    </div>
  )
}
